import { render, staticRenderFns } from "./ServiceTile.vue?vue&type=template&id=15641214&scoped=true&"
import script from "./ServiceTile.vue?vue&type=script&lang=js&"
export * from "./ServiceTile.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTile.vue?vue&type=style&index=0&id=15641214&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15641214",
  null
  
)

export default component.exports